'use es6';

import { createTracker } from 'usage-tracker';
import events from 'slack-ui-library/events.yaml';
export const UsageTracker = createTracker({
  events
});